import { ShapeProps } from './types';

export const Brackets = ({ className }: ShapeProps) => (
    <svg
        className={className}
        width="41"
        height="23"
        viewBox="0 0 41 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M29.959 2.00006C29.9526 7.16072 34.122 11.3353 39.2827 11.3353C34.122 11.3353 29.9422 15.51 29.9358 20.6706"
            stroke="#313131"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.8122 20.6706C11.8186 15.5099 7.6491 11.3354 2.48842 11.3354C7.6491 11.3354 11.8289 7.1607 11.8353 2.00005"
            stroke="#313131"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M19.016 20.6699L21.8178 2.00011"
            stroke="#313131"
            strokeWidth="3"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
